import React, { JSX } from 'react';

import { NumberCellFormatter } from '@evinced-private/ui-common';

export const renderNumberCellFormatter = (value: number): JSX.Element => {
	return <NumberCellFormatter value={value} />;
};
